'use strict';

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isFinite.js
 ** module id = 1281
 ** module chunks = 0
 **/